import { render, staticRenderFns } from "./WidgetFormGroup.vue?vue&type=template&id=27124077&"
import script from "./WidgetFormGroup.vue?vue&type=script&lang=js&"
export * from "./WidgetFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports